export default "__VITE_ASSET__Ce9j5jn9__"